/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';
import {CodemirrorFieldComponent} from '../common/directives/codemirror-field.component';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {GridsterWorkspaceComponent} from '../common/directives/gridster-workspace.component';
import {AdminRichTextFieldComponent} from '../common/directives/notes/admin-rich-text-field.component';
import {NotesComponent} from '../common/directives/notes/notes.component';
import {ObjectNotesButtonComponent} from '../common/directives/notes/object-notes-button.component';
import {ReportTemplateCopyModalComponent} from './report-template-copy-modal.component';
import {ReportTemplateEditPageComponent} from './report-template-edit-page.component';
import {ReportTemplateEditWorkspaceComponent} from './report-template-edit-workspace.component';
import {ReportTemplateGridsterItemComponent} from './report-template-gridster-item.component';
import {ReportTemplateListPageComponent} from './report-template-list-page.component';
import {ReportTemplateRoutePageComponent} from './report-template-route-page.component';
import {ReportTemplateWidgetModalComponent} from './report-template-widget-modal.component';

const REPORT_TEMPLATE_COMPONENTS = [
  ReportTemplateCopyModalComponent,
  ReportTemplateEditPageComponent,
  ReportTemplateEditWorkspaceComponent,
  ReportTemplateGridsterItemComponent,
  ReportTemplateListPageComponent,
  ReportTemplateRoutePageComponent,
  ReportTemplateWidgetModalComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminResourcePagesModule,
    CodemirrorFieldComponent,
    FormControlsModule,
    GridsterWorkspaceComponent,
    AdminRichTextFieldComponent,
    NotesComponent,
    ObjectNotesButtonComponent
  ],
  declarations: REPORT_TEMPLATE_COMPONENTS,
  exports: REPORT_TEMPLATE_COMPONENTS
})
export class ReportTemplateModule {
}
